import { iconsSet } from "../../../../assets/icons/icons";

export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_outliersinvest.png",
      alt: "Mockup da extensão Outliers Invest",
    },
    title: "Invista em robôs inteligentes que operam por você!",

    // String ou array de strings
    text: "Saia do comum e leve seus investimentos para outro nível. Com estratégias FORA DE SÉRIE, nossos robôs operam para você de forma automatizada, trazendo mais praticidade e inteligência para suas operações. Automatize suas operações e ganhe mais tempo no seu dia a dia.",
    testimonial: {
      text: "Acreditamos que confiança se constrói com transparência e integridade. Tudo o que fazemos reflete essa mentalidade.",
      author: {
        name: "Arthur Aquino e Felipe Hornung - sócios fundadores Outliers Invest.",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "ESTRATÉGIAS OUTLIERS INVEST",
    heading: "Curta a vida enquanto a tecnologia trabalha para você!",
    subtitle: "Estratégias inteligentes e validadas, ao seu alcance em poucos cliques.",
  },

  cta: {
    title: "Pronto para começar? Conheça nossos planos e comece agora mesmo!",
    subtitle: "Escolha seu plano!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Outliers Invest",
    col1: [
      "A história da Outliers Invest começou em 2013, quando Arthur Aquino e Felipe Hornung se conheceram no curso de Engenharia Elétrica da Universidade Tecnológica Federal do Paraná. Foi a partir da metade da graduação que surgiu o interesse pelo mercado financeiro e pelo desenvolvimento pessoal. Desde então, começaram a trocar livros sobre os temas e realizar cursos de day trade juntos.",
      "Após a formatura, Arthur foi para a Austrália para aprimorar o inglês e se especializar em gestão e projetos, onde também operava no mercado de day trade e criptomoedas. Ele já atuava nessa área desde 2016, adquirindo experiência prática em operações manuais antes de migrar para a automação. Enquanto isso, Felipe seguiu no Brasil, dedicando-se ao mestrado e, posteriormente, ao doutorado, no qual começou a estudar técnicas de inteligência artificial. Durante esse período, Felipe também trabalhou como professor particular de disciplinas de exatas, dando aulas para alunos do ensino médio e da graduação.",
      "Foi em março de 2022 que a jornada da Outliers Invest realmente começou. Ao perceberem o potencial das operações automatizadas, entenderam que esse seria seu propósito no mercado financeiro. A partir desse momento, passaram a se dedicar integralmente ao desenvolvimento de robôs de investimento, investindo intensamente em cursos, treinamentos e plataformas para obter o máximo de conhecimento e aprimorar continuamente suas soluções.",
    ],
    col2: [
      "O nome Outliers foi escolhido como uma referência ao livro Outliers, de Malcolm Gladwell, que explora como o sucesso é resultado de um conjunto de fatores, incluindo dedicação, aprendizado contínuo e a busca pela excelência — princípios que guiam a empresa desde a sua fundação.",
      "Com essa mentalidade, a Outliers Invest não parou de evoluir: Arthur e Felipe seguem investindo intensamente em aprendizado, pois acreditam que o conhecimento e a capacitação são essenciais para alcançar seus objetivos. Os objetivos? Criar estratégias de investimento duradouras, impactar o mercado financeiro e serem reconhecidos não apenas no Brasil, mas também internacionalmente.",
      "“O sucesso é uma combinação de talento e preparação” – Malcolm Gladwell, autor de Outliers – Fora de série. ",
    ],
  },

  stats: {
    title: "Conheça alguns números da Outliers Invest",
    subtitle: "Aperfeiçoamento contínuo para resultados excepcionais.",
    data: [
      {
        value: "+R$100k",
        description: "Investidos em conhecimento e ferramentas",
      },
      {
        value: "+3",
        description: "Anos desenvolvendo estratégias",
      },
      {
        value: "+10mi",
        description: "Estratégias testadas",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da Outliers Invest?",
    subtitle: "Veja quais as principais vantagens dos robôs da Outliers Invest",
    data: [
      {
        icon: iconsSet.play_circle,
        title: "Inteligência artificial",
        description: "Todas as nossas estratégias são desenvolvidas utilizando inteligência artificial.",
      },
      {
        icon: iconsSet.tune,
        title: "Validação estatística",
        description: "Todas as nossas estratégias são validadas através de diversos testes estatísticos.",
      },
      {
        icon: iconsSet.settings_outline,
        title: "Estratégias descorrelacionadas",
        description: "Nossos portfólios são construídos com estratégias descorrelacionadas que operam em conjunto.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte individual",
        description: "Estamos à disposição para tirar todas as suas dúvidas.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description: "Elimine o fator emocional das suas operações.",
      },
      {
        icon: iconsSet.calendar,
        title: "15 dias para testar ",
        description: "Teste gratuitamente por 15 dias.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Com a Outliers Invest eu nunca tive medo de ser enganada. Todo tempo sempre foi passado os riscos que estou exporta e mais que isso a margem desses riscos. Sempre soube que existiria a perda e que é preciso enxergar as coisas a longo prazo.",
      author: "Ângela Braga",
      job: "Bióloga",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "O diferencial da Outliers é justamente a transparência, a clareza nas informações. Acompanho desde o início, e mesmo antes de liberarem as vendas já havia esse compromisso com o futuro cliente.",
      author: "Wagner da Silva",
      job: "Supervisor de condomínio",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos.",
  },
};
